<template>
  <div class="input-select">
    <select v-model="sortMode">
      <option value="update-desc">
        {{ trans('offer.sort.last_update') }}
      </option>
      <option value="capacity-asc">
        {{ trans('offer.sort.capacity_asc') }}
      </option>
      <option value="capacity-desc">
        {{ trans('offer.sort.capacity_desc') }}
      </option>
      <option value="price-asc">
        {{ trans('offer.sort.price_asc') }}
      </option>
      <option value="price-desc">
        {{ trans('offer.sort.price_desc') }}
      </option>
    </select>
  </div>
</template>

<script>
import { trans } from '@elements/translation';
import { useOfferListStore } from '@stores/useOfferListStore';
import { storeToRefs } from 'pinia';

export default {
  setup() {
    const { sortMode } = storeToRefs(useOfferListStore());
    return {
      sortMode,
    };
  },
  methods: { trans },
};
</script>
